import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  Paper,
  Autocomplete,
  TextField,
} from "@mui/material";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import CloseIcon from "@mui/icons-material/Close";

const ShiftAssignDialog = (props) => {
  const {
    dataSource = [],
    titleContent,
    selectedValue,
    onChange,
    onOpen,
    onSubmit,
    translate = (key, fallback) => fallback || key,
    placeholder = "...",
    handleClose,
    isOpen,
  } = props;

  const getTranslation = (key, fallback) => {
    const res = translate ? translate(key) : null;
    return !res || res === key ? fallback : res;
  };

  // Trova l'oggetto selezionato nell'array per sincronizzare il valore dell'Autocomplete
  const safeDataSource = Array.isArray(dataSource) ? dataSource : [];
  const selectedOption =
  safeDataSource.find((item) => item && item.anaUserId === selectedValue) || null;

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      fullWidth
      maxWidth="xs"
      aria-labelledby="shift-assign-dialog-title"
    >
      {/* HEADER UNIFORMATO */}
      <DialogTitle
        id="shift-assign-dialog-title"
        sx={{
          bgcolor: "primary.main",
          color: "white",
          display: "flex",
          alignItems: "center",
          gap: 1,
          py: 1.5,
        }}
      >
        <PersonAddAlt1Icon sx={{ color: "white" }} />
        <Typography
          variant="h6"
          component="span"
          sx={{ color: "white", fontWeight: "bold", flex: 1 }}
        >
          {titleContent || getTranslation("assignShiftTitle", "Assegna Turno")}
        </Typography>
        <IconButton onClick={handleClose} sx={{ color: "white" }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {/* CONTENUTO */}
      <DialogContent sx={{ pt: "16px !important" }}>
        <Paper
          elevation={0}
          sx={{
            p: 2,
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 2,
            display: "flex",
            flexDirection: "column",
            gap: 2,
            bgcolor: "#fafafa",
          }}
        >
          <Typography variant="body2" color="text.primary">
            {getTranslation(
              "selectUserInstruction",
              "Seleziona il volontario da assegnare d'ufficio al turno:"
            )}
          </Typography>

          <Autocomplete
            id="acShiftAssign"
            options={safeDataSource}
            getOptionLabel={(option) => option.nameSurname || ""}
            isOptionEqualToValue={(option, value) => option.anaUserId === value.anaUserId}
            value={selectedOption}
            onOpen={onOpen}
            onChange={(event, newValue) => {
              if (onChange) {
                // Mantiene il contratto evento simile a quello precedente passando il valore o l'oggetto
                onChange({
                  value: newValue ? newValue.anaUserId : null,
                  itemData: newValue,
                });
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                placeholder={placeholder}
                variant="outlined"
              />
            )}
          />
        </Paper>
      </DialogContent>

      {/* FOOTER UNIFORMATO */}
      <DialogActions sx={{ p: 2, borderTop: "1px solid", borderColor: "divider", gap: 1 }}>
        <Button onClick={handleClose} variant="outlined" color="inherit" fullWidth>
          {getTranslation("cancelBtn", "Annulla")}
        </Button>
        <Button onClick={onSubmit} variant="contained" color="primary" fullWidth>
          {getTranslation("okBtn", "OK")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ShiftAssignDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  dataSource: PropTypes.array,
  selectedValue: PropTypes.any,
  titleContent: PropTypes.node,
  onChange: PropTypes.func,
  onOpen: PropTypes.func,
  translate: PropTypes.func,
  placeholder: PropTypes.string,
};

export default ShiftAssignDialog;